import { useQuery } from "react-query";
import { useLogs } from "./useLogs";

export const useGetLogsNames = () => {
  const { getLogsNames } = useLogs();

  const { data, isLoading, isError } = useQuery({
    queryKey: ["getLogsNames"],
    queryFn: () => getLogsNames().then((res) => res?.data.names),
  });
  return { data: data, isLoading, isError };
};
